export default __webpack_public_path__ + "static/media/tip13.b8b653e7.png";